// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-AttrCommonFields-ArticleTemplateInput-ArticleTemplateInput-module__box--u42Yt {
  display: grid;
  row-gap: 15px;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-AttrCommonFields-ArticleTemplateInput-ArticleTemplateInput-module__row--sQdZO {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-AttrCommonFields-ArticleTemplateInput-ArticleTemplateInput-module__checkboxCell--vscNd {
  margin-bottom: 0;
  display: flex;
  align-items: end;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ManagementPage/Obj2Tab/forms/AttrForm2/AttrCommonFields/ArticleTemplateInput/ArticleTemplateInput.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;AACF;AACA;EACE,aAAA;EACA,SAAA;EACA,sCAAA;AACF;AACA;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;AACF","sourcesContent":[".box {\n  display: grid;\n  row-gap: 15px;\n}\n.row {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n}\n.checkboxCell {\n  margin-bottom: 0;\n  display: flex;\n  align-items: end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-AttrCommonFields-ArticleTemplateInput-ArticleTemplateInput-module__box--u42Yt`,
	"row": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-AttrCommonFields-ArticleTemplateInput-ArticleTemplateInput-module__row--sQdZO`,
	"checkboxCell": `src-pages-ManagementPage-Obj2Tab-forms-AttrForm2-AttrCommonFields-ArticleTemplateInput-ArticleTemplateInput-module__checkboxCell--vscNd`
};
export default ___CSS_LOADER_EXPORT___;
